import { AppCoreEnums } from '../shared/enums';
import useRouteUtils from '../router-utils/route-utils';
import { useCoreStore } from '../../stores/core/store';
import { RouteLocationNormalized, useRoute } from 'vue-router';

export default () => {
  let route = useRoute();
  const { getContainerRouteName } = useRouteUtils();

  const getFiltersPreferenceKey = (containerType: AppCoreEnums.ContainerType) => {
    const userPreferencePostfixKey = getContainerRouteName(route, containerType);

    return `filters.${userPreferencePostfixKey}`;
  };

  const getTableColumnsPreferenceKey = (
    containerType: AppCoreEnums.ContainerType,
    toRoute: RouteLocationNormalized | undefined = undefined
  ) => {
    return `columns.${getUserPreferenceKeyPostfix(containerType, toRoute)}`;
  };

  const getPaginationPreferenceKey = (
    containerType: AppCoreEnums.ContainerType,
    toRoute: RouteLocationNormalized | undefined = undefined
  ) => {
    return `pagination.${getUserPreferenceKeyPostfix(containerType, toRoute)}`;
  };

  const getDrawerPaginationPreferenceKey = (idDrawer: string) => {
    return `pagination.${idDrawer}`;
  };

  const getDynamicFiltersPreferenceKey = (
    containerType: AppCoreEnums.ContainerType,
    toRoute: RouteLocationNormalized | undefined = undefined
  ) => {
    return `dynamicFilters.${getUserPreferenceKeyPostfix(containerType, toRoute)}`;
  };

  const getUserPreferenceKeyPostfix = (
    containerType: AppCoreEnums.ContainerType,
    toRoute: RouteLocationNormalized | undefined = undefined
  ) => {
    if (!toRoute && !route) route = useRoute();

    let userPreferencePostfixKey = toRoute
      ? getContainerRouteName(toRoute, containerType)
      : getContainerRouteName(route, containerType);

    if (containerType == AppCoreEnums.ContainerType.DrawerContainer) {
      userPreferencePostfixKey = useCoreStore().drawerInfo?.id || '';
    }

    return userPreferencePostfixKey;
  };

  return {
    getFiltersPreferenceKey,
    getPaginationPreferenceKey,
    getTableColumnsPreferenceKey,
    getDynamicFiltersPreferenceKey,
    getDrawerPaginationPreferenceKey,
  };
};
